import * as API from 'src/api/dev/package'
import { GET_APP_BASE } from '../app/types'
import * as T from './types'

export default {
    [T.GET_APP_BASE]({ dispatch }, payload) {
        return dispatch(GET_APP_BASE, payload, { root: true })
    },

    [T.GET_APP_ICON]({ commit }, payload) {
        commit(T.SET_APP_ICON, '')
        commit(T.SET_APP_SPLASH, { ios: {}, android: {} })
        return API.getIconAndSplash(payload)
            .then(res => {
                commit(T.SET_APP_ICON, res.android.icons || res.ios.icons)
                commit(T.SET_APP_SPLASH, {
                    ios: res.ios.splashes,
                    android: res.android.splashes
                })
                return res
            })
    },

    [T.GET_CORDOVA_CONFIG]({ commit }, payload) {
        commit(T.SET_CORDOVA_CONFIG, '')
        return API.getCordovaConfig(payload)
            .then(res => {
                commit(T.SET_CORDOVA_CONFIG, res)
                return res
            })
    },

    [T.SET_CORDOVA_CONFIG]({ commit }, payload) {
        return API.setCordovaConfig(payload)
            .then(res => {
                commit(T.SET_CORDOVA_CONFIG, payload.configs)
                return res
            })
    },

    [T.GET_IOS_CRED]({ commit }, payload) {
        commit(T.RESET_IOS_CRED)
        return API.getIosCred(payload)
            .then(res => {
                commit(T.SET_IOS_CRED, res)
                return res
            })
    },

    [T.GET_ANDROID_CRED]({ commit }, payload) {
        commit(T.RESET_ANDROID_CRED)
        return API.getAndroidCred(payload)
            .then(res => {
                commit(T.SET_ANDROID_CRED, res)
                return res
            })
    },

    [T.SET_ANDROID_CRED]({ commit }, payload) {
        return API.uploadAndroidCred(payload)
            .then(res => {
                const { package_type, sign, cert } = res
                const data = {
                    [package_type]: { sign, cert }
                }
                commit(T.SET_ANDROID_CRED, data)
                return res
            })
    },

    [T.SET_IOS_CRED]({ commit }, payload) {
        return API.uploadIosCred(payload)
            .then(res => {
                commit(T.SET_IOS_CRED_TYPE, res)
                return res
            })
    },

    [T.SET_IOS_PROFILE]({ commit }, payload) {
        return API.uploadIosProfile(payload)
            .then(res => {
                commit(T.SET_IOS_CRED_TYPE, res)
                return res
            })
    },

    [T.GET_ENGINE_LSIT]({ commit }, payload) {
        commit(T.SET_ENGINE_LSIT, { ios: [], android: [] })
        commit(T.SET_CURRENT_ENGINE, { ios: '', android: '' })

        return Promise.all([
            API.getEngineList({ ...payload, plugin: 'cordova-ios' }),
            API.getEngineList({ ...payload, plugin: 'cordova-android' })
        ])
            .then(res => {
                const ios = res[0]
                const android = res[1]
                const {
                    ios_engine_version: iosCurrent,
                    android_engine_version: androidCurrent
                } = { ...ios.current, ...android.current }
                commit(T.SET_ENGINE_LSIT, { ios: ios.list, android: android.list })
                commit(T.SET_CURRENT_ENGINE, { ios: iosCurrent || '', android: androidCurrent || '' })
                return res
            })
    },

    [T.SET_CURRENT_ENGINE]({ commit }, payload) {
        return API.setEngine(payload)
            .then(res => {
                commit(T.SET_CURRENT_ENGINE, { [payload.platform]: payload.version })
                return res
            })
    },

    [T.GET_HOOKS]({ commit }, payload) {
        commit(T.SET_HOOKS, [])
        return API.getHooks(payload.app_id)
            .then(res => {
                commit(T.SET_HOOKS, res)
                return res
            })
    },

    [T.ADD_HOOK]({ commit }, payload) {
        const data = new FormData()
        Object.keys(payload).forEach(key => {
            data.append(key, payload[key])
        })
        return API.addHook(data)
            .then(res => {
                commit(T.ADD_HOOK, { ...payload, url: res })
                return res
            })
    },

    [T.DELETE_HOOK]({ commit }, payload) {
        return API.deleteHook(payload)
            .then(res => {
                commit(T.DELETE_HOOK, payload)
                return res
            })
    },

    [T.DOWNLOAD_HOOK](store, payload) {
        return API.downloadHook(payload)
    },

    [T.GET_PLUGIN_STATUS]({ commit }, payload) {
        return API.getPluginStatus(payload)
            .then(res => {
                commit(T.SET_PLUGIN_STATUS, res.plugflag)
                return res
            })
    },

    [T.GET_PLUGIN_LIST]({ commit }, payload) {
        return API.getPlugins(payload)
            .then(res => {
                commit(T.SET_PLUGIN_LIST, res)
                return res
            })
    },

    [T.GET_PLUGIN_LOG](store, payload) {
        return API.getPluginLog(payload)
    },

    [T.GET_PLUGIN_PARAMS](store, payload) {
        return API.getPluginParams(payload)
            .then(res => res.list)
    },

    [T.UPDATE_PLUGIN](store, payload) {
        return API.updatePlugin(payload)
    },

    [T.CREATE_PACKAGE](store, payload) {
        return API.startPackage(payload)
    },

    [T.RE_PACKAGE](store, payload) {
        return API.rePackage(payload)
    },

    [T.GET_PACKAGE_LIST]({ commit }, payload) {
        return API.getPackageList(payload)
            .then(res => {
                commit(T.SET_PACKAGE_LIST, res.items)
                commit(T.SET_APP_VERSION, res.webapp_version || [])
                return res
            })
    },

    [T.GET_QRCODE](store, payload) {
        return API.getQrcode(payload)
    },

    [T.UPLOAD_APP](store, payload) {
        return API.uploadApp(payload)
    }
}
